/* Mobile drill-down menu engine (rebuild step 2, 2026-07-09).
   Plain-JS rewrite of the jQuery drill-down that used to live in
   mega-menu.js. Same markup and CSS: panels still open by inline
   display, the whole tree still slides by moving .top-menu's left by
   one container-width per level, the back bar and title behave the
   same, including the original's 400ms settle timer. jQuery is no
   longer loaded in header.liquid (removed with the product page
   de-dup, 2026-07-10); the product page loads its own copy for its
   sticky-submit script, and nothing else on the site uses it.

   One inherited quirk kept on purpose: tapping the hamburger while the
   drawer is open toggles it closed but leaves body scrolling locked,
   exactly like the old code. The close (X) buttons unlock correctly. */

(function () {
  'use strict';

  var ARROW_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">' +
    '<path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" /></svg>';
  var BACK_CHEVRON =
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">' +
    '<path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" /></svg>';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var container = document.querySelector('.mobile-navigation-container');
    if (!container) return;

    var backBtn = document.querySelector('.back-button');
    var backClose = document.querySelector('.back-button-close');
    var backBar = document.querySelector('.back_and_close_btn_container');
    var logo = document.querySelector('.mobile_logo_container');
    var showBtn = document.getElementById('show_menu');
    var closeBtn = document.getElementById('close_menu');

    function isVisible(el) {
      return !!el && getComputedStyle(el).display !== 'none';
    }

    function currentMenu() {
      return document.querySelector('.current-menu');
    }

    function titleHtml(text) {
      return (
        '<div class="dynamic_menu_title"><div>' + BACK_CHEVRON + '</div>' +
        '<div><p>' + text + '</p></div></div>'
      );
    }

    /* slide the whole menu tree one container-width left (-1) or right (+1) */
    function slideTop(direction) {
      var top = document.querySelector('.top-menu');
      if (!top) return;
      var left = parseFloat(getComputedStyle(top).left) || 0;
      var width = Math.round(container.getBoundingClientRect().width);
      top.style.left = left + direction * width + 'px';
    }

    function setArrowState(trigger, open) {
      var arrow = trigger && trigger.querySelector('button.arrow');
      if (arrow) arrow.setAttribute('aria-expanded', String(open));
    }

    /* ----- drawer open / close ----- */
    if (showBtn) {
      showBtn.addEventListener('click', function () {
        container.classList.toggle('show-mobile-navigation-container');
        document.body.style.overflow = 'hidden';
      });
    }

    function closeDrawer() {
      container.classList.remove('show-mobile-navigation-container');
      document.body.style.overflow = '';
    }
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backClose) backClose.addEventListener('click', closeDrawer);

    /* ----- mark the top-level list ----- */
    document.querySelectorAll('.custom-mobile-menu').forEach(function (menu) {
      Array.prototype.forEach.call(menu.children, function (child) {
        if (child.classList.contains('dynamic_menu_gap')) child.classList.add('top-menu');
      });
    });

    /* ----- submenu triggers: inject the arrow, bind drill-in ----- */
    document.querySelectorAll('.has_child_menu .inner_menu').forEach(function (trigger) {
      var arrow = document.createElement('button');
      arrow.className = 'arrow';
      arrow.setAttribute('aria-label', 'Toggle submenu');
      arrow.setAttribute('aria-expanded', 'false');
      arrow.innerHTML = ARROW_SVG;
      trigger.appendChild(arrow);

      trigger.addEventListener('click', function (e) {
        e.preventDefault();

        var submenu = null;
        Array.prototype.forEach.call(trigger.parentElement.children, function (sib) {
          if (sib !== trigger && sib.classList.contains('dynamic_menu_gap')) submenu = sib;
        });
        if (!submenu) return;

        /* second tap on an already-open trigger collapses it in place */
        if (isVisible(submenu)) {
          submenu.style.display = 'none';
          setArrowState(trigger, false);
          return;
        }

        var prev = currentMenu();
        if (prev) prev.classList.remove('current-menu');

        submenu.style.display = 'block';
        submenu.classList.add('current-menu');
        slideTop(-1);

        if (!isVisible(backBtn)) {
          if (backBtn) backBtn.style.display = 'flex';
          if (backClose) backClose.style.display = 'flex';
          if (backBar) backBar.style.display = 'flex';
        }
        if (backBtn) backBtn.innerHTML = titleHtml(trigger.textContent);
        if (logo) logo.style.display = 'none';
        setArrowState(trigger, true);
      });
    });

    /* ----- back button: up one level ----- */
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        var cur = currentMenu();
        if (!cur) return;

        var parentList = cur.parentElement && cur.parentElement.parentElement;
        var atTop = !!(parentList && parentList.classList.contains('top-menu'));

        if (atTop) {
          backBtn.style.display = 'none';
          if (backClose) backClose.style.display = 'none';
          if (backBar) backBar.style.display = 'none';
          backBtn.textContent = 'Back';
          if (logo) logo.style.display = '';
        } else if (parentList && parentList.parentElement) {
          /* title becomes the level above: that list's own trigger text */
          var upTrigger = null;
          Array.prototype.forEach.call(parentList.parentElement.children, function (sib) {
            if (sib !== parentList && sib.classList.contains('inner_menu')) upTrigger = sib;
          });
          if (upTrigger) backBtn.innerHTML = titleHtml(upTrigger.textContent);
        }

        slideTop(1);

        /* same settle timer as the original: hide the level we left and
           hand the current-menu marker to the level we returned to */
        window.setTimeout(function () {
          var c = currentMenu();
          if (!c) return;
          c.style.display = 'none';

          var trigger = null;
          Array.prototype.forEach.call(c.parentElement.children, function (sib) {
            if (sib !== c && sib.classList.contains('inner_menu')) trigger = sib;
          });
          setArrowState(trigger, false);

          var up = c.parentElement && c.parentElement.parentElement;
          if (up) up.classList.add('current-menu');
          document.querySelectorAll('.current-menu .current-menu').forEach(function (el) {
            el.classList.remove('current-menu');
          });
        }, 400);
      });
    }
  });
})();
